import React from "react";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Modal } from "react-responsive-modal";
import { withRouter } from "react-router-dom";
const CutOffPopUp = ({ history, setEditUserOpen, edituserOpen }) => {
  const onCloseUserModal = () => setEditUserOpen(false);
  const { register, handleSubmit, errors } = useForm({});
  const cutOfPopupp = async (data) => {
    setEditUserOpen(false);
  };
  return (
    <div className="">
      <Modal
        open={edituserOpen}
        closeOnEsc={false}
        onClose={onCloseUserModal}
        closeOnOverlayClick={false}
        showCloseIcon={false}
      >
        <form onSubmit={handleSubmit(cutOfPopupp)}>
          <ul>
            <li className="inline-block text-sm leading-8 w-full">
              <label>Have you done the sweep</label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <span className="block">
                <input
                  type="checkbox"
                  name="sweepStatus"
                  value="Yes"
                  className="mr-2"
                  ref={register({
                    required: "You must select Yes",
                  })}
                />
                Yes
              </span>
              {errors.sweepStatus && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  {errors.sweepStatus?.message}
                </p>
              )}
            </li>
            <li className="inline-block text-sm leading-8 w-full">
              <label>Have you induced all blue bins?</label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <span className="block">
                <input
                  type="checkbox"
                  name="blueBin"
                  ref={register({
                    required: "You must select Yes",
                  })}
                  value="Yes"
                  className="mr-2"
                />
                Yes
              </span>
              {errors.blueBin && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  {errors.blueBin?.message}
                </p>
              )}
            </li>
            <li className="text-center">
              <button
                type="submit"
                className="text-white w-full sm:w-auto h-8 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
              >
                SUBMIT
              </button>
            </li>
          </ul>
        </form>
      </Modal>
    </div>
  );
};
export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(CutOffPopUp)
);
